import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetResultModalDataTypes } from "../../../../Schema/getResultModalData.types";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";

export type GetResultModalDataLoadAction = {
  type: string;
  payload: {
    segment_id: number;
    sub_service_id: number;
    user_service_id: number;
  };
};

export type GetResultModalDataData = {
  data: GetResultModalDataTypes;
};

const GetResultModalData = new ReduxFetchState<
  GetResultModalDataData | null,
  {
    segment_id: number;
    sub_service_id: number;
    user_service_id: number;
  },
  any
>("getResultModalData");

export function* watchGetResultModalData(action: GetResultModalDataLoadAction) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetResultModalDataData = yield axios({
      url: `/api/v1/ai/segment/call-sub-service`,
      method: "POST",
      headers: {
        lang,
      },
      data: { ...action.payload },
    });

    yield put(GetResultModalData.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetResultModalData.actions.loadFailure(e.message));
  }
}

export function* getResultModalDataSagas() {
  yield takeEvery(GetResultModalData.actionTypes.load, watchGetResultModalData);
}

export function useGetResultModalData() {
  const { loading, data, ...getResultModalDataState } = useAppSelector(
    (state) => state.getResultModalData,
  );
  const dispatch = useAppDispatch();

  const dispatchGetResultModalData = useCallback(
    (data: {
      segment_id: number;
      sub_service_id: number;
      user_service_id: number;
    }) => {
      dispatch(GetResultModalData.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getResultModalDataState,
    dispatchGetResultModalData,
    getResultModalDataLoading: loading,
    getResultModalData: data,
  };
}

export const {
  actionTypes: getResultModalDataActionsTypes,
  actions: getResultModalDataActions,
  reducer: getResultModalDataReducer,
} = GetResultModalData;
